import { createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from 'app/store';

import ApplicationsService from 'features/applications/applicationsService';
import { generateParams } from 'features/filters/filtersSlice';

import { Filters, SortOrders } from 'types/filters';

import { AppModules } from 'constants/enums';
import { MODULE_DEFAULT_FACET_FIELDS } from 'constants/facets';
import { MAX_DASHBOARD_APPLICATIONS_TO_SHOW } from 'constants/uiSettings';

export const fetchApplicationsData = createAsyncThunk(
  'applications/getApplications',
  async (locale: string, { getState, rejectWithValue }) => {
    const state = getState() as RootState;
    const params = generateParams({
      ...state.filters,
      locale,
      facetFields: MODULE_DEFAULT_FACET_FIELDS[AppModules.Applications]
    });

    try {
      const response = await ApplicationsService.getApplications(params);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchAceApplicationsData = createAsyncThunk(
  'applications/getAceApplications',
  async (filters: Filters, { rejectWithValue }) => {
    try {
      const response = await ApplicationsService.getAceApplications(filters);

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchApplicationsForDashboard = createAsyncThunk(
  'jobs/fetchApplicationsForDashboard',
  async (locale: string, { rejectWithValue }) => {
    try {
      const params = generateParams({
        sortField: 'createdDate',
        sortOrder: SortOrders.Asc,
        pageSize: MAX_DASHBOARD_APPLICATIONS_TO_SHOW,
        locale
      });

      const response = await ApplicationsService.getApplications(params);

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchActiveApplicationDetails = createAsyncThunk(
  'jobs/fetchActiveApplicationDetails',
  async (
    { applicationId, locale }: { applicationId: string; locale: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await ApplicationsService.getApplicationById(
        applicationId,
        locale
      );

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
